import React from 'react'
import { useQuery } from 'react-apollo'

import { Link } from 'react-router-dom'

import { getArticles } from './get-academy-articles'
import {
  DooerComGetAcademyArticles,
  DooerComGetAcademyArticlesVariables,
} from './__generated__/DooerComGetAcademyArticles'

interface IArticleCategory {
  slug?: string | null
  path?: string | null
  category?: IArticleCategory | null
  parentCategory?: IArticleCategory | null
}

function createArticlePath(articleOrCategory: IArticleCategory): IArticleCategory | string {
  const path = [articleOrCategory.slug, articleOrCategory.path].filter(Boolean).join('/')

  return articleOrCategory.category == null && articleOrCategory.parentCategory == null
    ? path
    : createArticlePath({ ...(articleOrCategory.parentCategory || {}), ...(articleOrCategory.category || {}), path })
}

interface IXrayLinkProps {
  children: React.ReactNode
  xrayId: string
}

export default function XrayLink(props: IXrayLinkProps) {
  const { data } = useQuery<DooerComGetAcademyArticles, DooerComGetAcademyArticlesVariables>(getArticles, {
    variables: { filter: `xrayId eq "${props.xrayId}" and targets any in ["public"]` },
  })

  const article = data?.academy?.articles?.edges[0]?.node ?? null

  if (!article) {
    return <span>{props.children}</span>
  }

  return (
    <Link {...props} to={`/hjalp/${createArticlePath(article)}`}>
      {props.children}
    </Link>
  )
}
